import React, { useEffect, useState } from "react";
import { useHookstate } from "@hookstate/core";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import CloseIcon from "assets/svgIcons/CloseIcon";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { PopUpContainer } from "assets/css/globle";
import CloseOutIcon from "assets/svgIcons/ModalCloseOutIcon";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MenuItem from "@mui/material/MenuItem";
import Checkbox from "@mui/material/Checkbox";
import UnCheckIcon from "assets/svgIcons/UncheckIcon";
import CheckIcon from "assets/svgIcons/CheckIcon";
import CheckAdminIcon from "assets/svgIcons/CheckedAdminIcon";
import SettingIconNew from "assets//svgIcons/SideNav/Settings";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import LockIcon from "assets/svgIcons/LockIcon";
import UnLockIcon from "assets/svgIcons/UnlockIcon";
import { useDispatch, useSelector } from "react-redux";
import {
  COMMON_SERVICES,
  headersConfigData,
} from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
  API_CALLS,
  updateCarTypeApiCall,
} from "redux/reduxToolkitServices/_commonApiCalls/api";
import { ChangeSettingModalWrapper } from "pages/Fleet/Cars/SortByHeader/SortByHeaderStyled";
import {
  FLEET_GLOBAL_STATES,
  MAP_GLOBAL_STATES,
  CAR_NUMBER_MESSAGE,
  UPDATED_CAR_DATA_STATE,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import {
  carProductData as carProductDataAction,
} from "redux/reduxToolkitServices/_commonReducers/commonReducers";
import { useTranslation } from "react-i18next";
import { isUserMaster, getFeatureSetOption, getFeaturesList, carType, isUserAdmin, isUserSupport, isUserBasic, isUserReadOnly, speedLimitConst, distances, holesConst, deviceType, controlType } from "constant";
import { useCarSettingsData } from "_helperFunctions/carSettings";
import { Button } from "@mui/material";
import _ from "lodash";
import { Loader } from "../../commonComponents/Loader/Loader";
import { getGuardianState } from "_helperFunctions/guardianState";

let maxHolesOptions = [
  { name: "Use fleet setting", val: 0 },
  { name: "9", val: 9 },
  { name: "18", val: 18 },
  { name: "Unlimited", val: -1 },
];
let distEnabledCarOptions = [
  { name: "Hide distances", val: 0 },
  { name: "Show Distances", val: 1 },
  { name: "Use fleet setting", val: 2 },
];

const CarSettings = () => {
  const { getUserRole, siteSettingsData } = useSelector((state) => state.commonReducers) || [];

  const { isSiteUsingYards, checkIfCarCanStage, guardianMode, isStagingMode } = useCarSettingsData();

  const { t } = useTranslation();

  const {
    selectedCarList,
    selectedSpeedCarList,
    selectFleetCarsData,
    selectFleetCarsData2,
    selectedDistanceUnits,
    selectedDistancesEnabledCar,
    selectMaxHolesCarList,
    selectCarTypeCarList,
    selectedGpsCarList,
    closingPopup,
    toggleSelectedCars,
    toggleUnselectedCars,
    selectedCarList2,
  } = useHookstate(FLEET_GLOBAL_STATES);

  const {
    setCarNumber,
    carMessageSelector,
    carsForMessagesGetter,
    carsGpsSelectorData,
    carsForMessagesGetter2,
    carsGpsSelectorData2,
  } = useHookstate(CAR_NUMBER_MESSAGE);

  const { showTaggedCarArray, showTaggedCarArrayNew } = useHookstate(MAP_GLOBAL_STATES);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  const dispatch = useDispatch();

  const { updatedCarData } = useHookstate(UPDATED_CAR_DATA_STATE);

  const [stagedCars, setStagedCars] = useState([]);
  const [enabledCars, setEnabledCars] = useState([]);
  const [activeButton, setActiveButton] = useState(false);
  const [enabledCarsChecked, setEnabledCarsChecked] = useState(false);
  const [stagedCarsChecked, setStagedCarsChecked] = useState(false);
  const [distancesEnabled, setDistancesEnabled] = useState(distances.select);
  const [newCarType, setCarType] = useState(carType.select);
  const [secondaryCarType, setSecondaryCarType] = useState(0);
  const [memberCarFound, setMemberCarFound] = useState(false);
  const [holes, setHoles] = useState("");
  const [speedLimit, setSpeedLimit] = useState(speedLimitConst.select);
  const [distance, setDistance] = useState(null);
  const [deregister, setDeregister] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [okPopUp, setOkPopUp] = useState(false);
  const [guardianConfirm, setGuardianConfirm] = useState(false);
  const [deregisterConfirm, setDeregisterConfirm] = useState(false);
  const [showSettingData, setShowSettingData] = useState(false);
  const [carSettingsData, setCarSettingsData] = useState(JSON.parse(JSON.stringify([])));
  const enableMemberCar = ((isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) || !getFeatureSetOption(siteSettingsData?.Features, getFeaturesList().member_cars))) && !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role));
  const guardianState = getGuardianState(selectFleetCarsData.get());
  const [guardianCapable, setGuardianCapable] = useState(guardianState?.checked);

  const enableSave = !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)) && activeButton && !memberCarFound && showSettingData;
  const shouldInputBeEnable = !(isUserBasic(getUserRole && getUserRole?.Role) || isUserReadOnly(getUserRole && getUserRole?.Role)) && !memberCarFound && showSettingData;
  const confirmPopupStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "400px",
    width: "calc(100% - 40px)",
    bgcolor: "background.paper",
    borderRadius: "5px",
    overflow: "hidden",
  };
  const warningStyle = {
    marginBottom: "10px",
    color: guardianState?.disabled ? "#F59E0B" : "#FA3C30",
    fontSize: "13px",
    display: "block"
  };

  let txt = "";

  const allCarsData = updatedCarData.get() && updatedCarData.get().length !== 0 ? JSON.parse(updatedCarData.get()) : [];

  const propertyValues = selectedCarList.get().length !== 0 ? Object.values(selectedCarList.get()) : Object.values(showTaggedCarArrayNew.get());
  propertyValues.sort((a, b) => a - b).forEach(myFunction);

  function myFunction(value) {
    txt += value + ",";
  }

  const tx2new = txt.substring(0, txt.length - 1);

  useEffect(() => {
    let stagedCarsDataArray = [];
    let enableCarsDataArray = [];

    if (selectFleetCarsData.get()?.length !== 0) {
      let memberCar = selectFleetCarsData.get().filter(car => car.CarType === carType?.member);
      setMemberCarFound(selectFleetCarsData.get()?.length > 1 && memberCar?.length > 0 && getFeatureSetOption(
        siteSettingsData?.Features,
        getFeaturesList().member_cars
      ));
      selectFleetCarsData.get().map(async (item) => {
        await API_CALLS.getProductApicall(
          item?.GpsiCarId,
          headersConfigData
        )
          .then((response) => response.json())
          .then((data) => {
            setCarSettingsData((prevVal) =>
              JSON.parse(JSON.stringify([...prevVal, data]))
            );
            setShowSettingData(true);
          });
      });

      selectFleetCarsData.get().map((car) => {
        if (checkIfCarCanStage(car)) {
          enableCarsDataArray.push(car);
        } else {
          stagedCarsDataArray.push(car);
        }
      })

    } else if (selectFleetCarsData2.get()?.length !== 0) {
      selectFleetCarsData2.get().map((item) => {
        API_CALLS.getProductApicall(item?.GpsiCarId, headersConfigData)
          .then((response) => response.json())
          .then((data) => {
            setCarSettingsData((prevVal) =>
              JSON.parse(JSON.stringify([...prevVal, data]))
            );
            setShowSettingData(true);
          });
      });

      selectFleetCarsData2.get().map((car) => {
        if (checkIfCarCanStage(car)) {
          enableCarsDataArray.push(car);
        } else {
          stagedCarsDataArray.push(car);
        }
      });
    }

    setStagedCars(stagedCarsDataArray);
    setEnabledCars(enableCarsDataArray);
  }, []);

  useEffect(() => {
    if (carSettingsData?.length === selectedCarList.get()?.length && carSettingsData?.length > 0) {
      if (carSettingsData.every(obj => obj.MaxSpeed === carSettingsData[0].MaxSpeed) || carSettingsData.every(obj => obj.MaxSpeed === 0 || obj.MaxSpeed === -1)) {
        setSpeedLimit(carSettingsData[0].MaxSpeed);
      }

      if (carSettingsData.every(obj => obj.DistanceUnits === carSettingsData[0].DistanceUnits)) {
        setDistance(carSettingsData[0].DistanceUnits);
      }

      if (carSettingsData.every(obj => obj.CarType === carSettingsData[0].CarType)) {
        setCarType(carSettingsData[0].CarType === carType.member && carSettingsData[0].SecondaryCarType === carType.handicap ? 7 : carSettingsData[0].CarType);
      }

      handleDistanceEnabled();

      handleHoles();
    }
  }, [carSettingsData]);

  useEffect(() => {
    if (
      stagedCars &&
      stagedCars.length > 0 &&
      carSettingsData &&
      carSettingsData.length > 0
    ) {
      let isStagedCarsEnabled = _.reduce(
        stagedCars?.map(checkIfStagedCar),
        reduceNullableBooleanValue
      );

      setEnabledCarsChecked(!isStagedCarsEnabled);
    }
  }, [stagedCars, carSettingsData]);

  useEffect(() => {
    var isEnabled = false;

    if (
      siteSettingsData?.GuardianMode === guardianMode.staging &&
      enabledCars &&
      enabledCars.length > 0
    ) {
      isEnabled = _.reduce(
        enabledCars.map(checkIfEnabledCar),
        reduceNullableBooleanValue
      );
    } else if (
      siteSettingsData &&
      siteSettingsData?.GuardianMode === guardianMode.lockdown
    ) {
      if (selectFleetCarsData.get() && selectFleetCarsData.get().length > 0) {
        isEnabled = _.reduce(
          selectFleetCarsData.get()?.map(checkIfEnabledCar),
          reduceNullableBooleanValue
        ); // server ATM true, versions n/a
      } else {
        isEnabled = _.reduce(
          selectFleetCarsData2.get()?.map(checkIfEnabledCar),
          reduceNullableBooleanValue
        ); // server ATM true, versions n/a
      }
    } else {
      if (selectFleetCarsData.get() && selectFleetCarsData.get().length > 0) {
        isEnabled = allValuesEqual(
          selectFleetCarsData.get()?.map(function (car) {
            let carSettings = findSettings(car);
            return carSettings?.AllowedToMove;
          })
        ); // should be n/a, but just in case...
      } else {
        isEnabled = allValuesEqual(
          selectFleetCarsData2.get()?.map(function (car) {
            let carSettings = findSettings(car);
            return carSettings?.AllowedToMove;
          })
        ); // should be n/a, but just in case...
      }
    }

    setStagedCarsChecked(isEnabled);
  }, [enabledCars, carSettingsData]);

  const holesChange = (e) => {
    setActiveButton(true);
    setHoles(e.target.value);
  }

  const handleSpeedLimit = (e) => {
    setActiveButton(true);
    setSpeedLimit(e.target.value);
  }

  const yardsHandle = (data) => {
    if (distance === 1) {
      setDistance(data);
    } else if (distance === 2) {
      setDistance(data);
    } else {
      setDistance(data);
    }
    setActiveButton(true);
  }

  const handleDistanceEnabled = () => {
    let computedDistEnabledCar =
      carSettingsData.length === 1
        ? carSettingsData[0]?.DistancesEnabledCar
        : carSettingsData
          ?.map(function (setting) {
            return getDistEnabledCarOption(setting?.DistancesEnabledCar);
          })
          .reduce(function (a, b) {
            if (a === null) {
              return null;
            } else if (b === null) {
              return a;
            } else if (a?.name === b?.name) {
              return a;
            } else {
              return null;
            }
          });
    if (computedDistEnabledCar === null) {
      setDistancesEnabled(distances.select);
    } else if (typeof computedDistEnabledCar === "object") {
      setDistancesEnabled(computedDistEnabledCar?.val);
    } else {
      setDistancesEnabled(computedDistEnabledCar);
    }
    setDeregister(carSettingsData[0]?.Deregister);
  }

  const handleHoles = () => {
    let computedMaxHoles =
      carSettingsData.length === 1
        ? carSettingsData[0]?.MaxHolesAllowedCar || maxHolesOptions[0].val
        : carSettingsData
          ?.map(function (carSettings) {
            return (
              carSettings?.MaxHolesAllowedCar || maxHolesOptions[0].val
            );
          })
          .reduce(function (a, b) {
            if (a === b) {
              return a;
            } else {
              return null;
            }
          });
    setHoles(computedMaxHoles);
  }

  const reduceBooleanValue = (a, b) => {
    return a === b ? a : false;
  }

  function getDistEnabledCarOption(val) {
    let entry;
    if (carSettingsData) {
      entry = distEnabledCarOptions.filter(function (option) {
        return option.val == val;
      });
    }
    return entry && entry.length > 0 ? entry[0] : distEnabledCarOptions[2]; // Return actual or default.
  }

  const findSettings = (car) => {
    var filtered =
      carSettingsData &&
      carSettingsData.length > 0 &&
      carSettingsData?.filter(function (settings) {
        return (
          car?.GpsiCarId &&
          settings &&
          settings?.GpsiCarId &&
          car?.GpsiCarId === settings?.GpsiCarId
        );
      });
    if (filtered.length > 0) {
      return filtered[0];
    }
    // missing settings
    else {
      return null;
    }
  }

  const checkIfCarCanEnable = (car) => {
    var carSettings = findSettings(car);
    return !(car?.AllowedToMove && carSettings?.AllowedToMove);
  }

  const canEnable2 = () => {
    if (siteSettingsData && siteSettingsData?.GuardianCapable) {
      if (siteSettingsData.GuardianMode === guardianMode.lockdown) {
        return true;
      } else {
        var canEnableCars = false;
        var cars = stagedCars;
        switch (cars.length) {
          case 0:
            return false;
          case 1:
            return checkIfCarCanEnable(cars[0]);
          default:
            return _.reduce(cars.map(checkIfCarCanEnable), reduceBooleanValue);
        }
      }
    } else {
      return false;
    }
  }

  const canStage2 = () => {
    if (isStagingMode()) {
      var cars = enabledCars;
      switch (cars.length) {
        case 0:
          return false;
        case 1:
          return checkIfCarCanStage(cars[0]);
        default:
          return _.reduce(cars.map(checkIfCarCanStage), reduceBooleanValue);
      }
    } else {
      return false;
    }
  }

  function lockdownString() {
    const carsData =
      updatedCarData.get() && updatedCarData.get().length !== 0
        ? JSON.parse(updatedCarData.get())
        : [];
    let str = "Enable" + " ";

    if (selectFleetCarsData.get() && selectFleetCarsData.get().length !== 0) {
      if (selectFleetCarsData.get().length === 1) {
        str =
          str +
          "Car".toLowerCase() +
          ": " +
          (selectFleetCarsData.get()[0]
            ? selectFleetCarsData.get()[0]?.CarNumber
            : "");
      } else {
        str =
          str +
          (selectFleetCarsData.get()?.length === carsData?.length
            ? "All".toLowerCase()
            : selectFleetCarsData.get().length) +
          " " +
          (selectFleetCarsData.get().length === 0 ||
            selectFleetCarsData.get().length > 1
            ? "Cars".toLowerCase()
            : "Car".toLowerCase());
      }
    } else if (
      selectFleetCarsData2.get() &&
      selectFleetCarsData2.get().length !== 0
    ) {
      if (selectFleetCarsData2.get().length === 1) {
        str =
          str +
          "Car".toLowerCase() +
          ": " +
          (selectFleetCarsData2.get()[0]
            ? selectFleetCarsData2.get()[0]?.CarNumber
            : "");
      } else {
        str =
          str +
          (selectFleetCarsData2.get()?.length === carsData?.length
            ? "All".toLowerCase()
            : selectFleetCarsData2.get().length) +
          " " +
          (selectFleetCarsData2.get().length === 0 ||
            selectFleetCarsData2.get().length > 1
            ? "Cars".toLowerCase()
            : "Car".toLowerCase());
      }
    }

    return str;
  }

  function carsStagedString() {
    const carsData =
      updatedCarData.get() && updatedCarData.get().length !== 0
        ? JSON.parse(updatedCarData.get())
        : [];

    var str = "Stage" + " ";
    if (enabledCars.length === 1) {
      str =
        str +
        "Car".toLowerCase() +
        ": " +
        (enabledCars[0] ? enabledCars[0]?.CarNumber : "");
    } else {
      str =
        str +
        (enabledCars?.length === carsData?.length
          ? "All".toLowerCase()
          : enabledCars.length) +
        " " +
        (enabledCars.length === 0 || enabledCars.length > 1
          ? "Cars".toLowerCase()
          : "Car".toLowerCase());
    }

    return str;
  }

  function carsEnabledString() {
    const carsData =
      updatedCarData.get() && updatedCarData.get().length !== 0
        ? JSON.parse(updatedCarData.get())
        : [];

    var str = "Enable" + " ";
    if (stagedCars.length === 1) {
      str =
        str +
        "Car".toLowerCase() +
        ": " +
        (stagedCars[0] ? stagedCars[0]?.CarNumber : "");
    } else {
      str =
        str +
        (stagedCars?.length === carsData?.length
          ? "All".toLowerCase()
          : stagedCars.length) +
        " " +
        (stagedCars.length === 0 || stagedCars.length > 1
          ? "Cars".toLowerCase()
          : "Car".toLowerCase());
    }
    return str;
  }

  var checkIfStagedCar = function (car) {
    var carSettings = findSettings(car);
    return !carSettings?.AllowedToMove;
  };

  var reduceNullableBooleanValue = function (a, b) {
    if (a === b) {
      return a;
    } else {
      return null;
    }
  };

  var checkIfEnabledCar = function (car) {
    var carSettings = findSettings(car);

    switch (siteSettingsData && siteSettingsData?.GuardianMode) {
      case guardianMode.staging:
        return !(carSettings?.AllowedToMove && car?.AllowedToMove);
      default:
        return carSettings?.AllowedToMove;
    }
  };

  function allValuesEqual(array) {
    if (array.length === 0) {
      return false;
    }

    return array.every(function (element) {
      return element === array[0];
    });
  }
  function getDifference(array1, array2) {
    return array1.filter((object1) => {
      return !array2.some((object2) => {
        return object1.Car.CarNumber === object2.CarNumber;
      });
    });
  }

  const saveEntity = () => {
    setActiveButton(false);

    let settings;

    if (selectFleetCarsData.get()?.length > 0) {
      if (deregister) {
        let tempData = getDifference(allCarsData, selectFleetCarsData.get());
        updatedCarData.set(JSON.stringify(tempData));
      }

      selectFleetCarsData.get()?.forEach((car) => {
        settings = findSettings(car);

        if (siteSettingsData?.GuardianMode === guardianMode.lockdown) {
          settings.AllowedToMove = stagedCarsChecked;
        } else if (siteSettingsData?.GuardianMode === guardianMode.staging) {
          if (enabledCars?.some((o) => o.GpsiCarId === car?.GpsiCarId)) {
            settings.AllowedToMove = !stagedCarsChecked;
          } else if (stagedCars?.some((o) => o.GpsiCarId === car?.GpsiCarId)) {
            settings.AllowedToMove = enabledCarsChecked;
          }
        } else {
          settings.AllowedToMove = stagedCarsChecked;
        }
      });
    } else {
      if (selectFleetCarsData2.get()?.length > 0) {
        if (deregister) {
          let tempData = getDifference(allCarsData, selectFleetCarsData2.get());
          updatedCarData.set(JSON.stringify(tempData));
        }

        selectFleetCarsData2.get()?.forEach((car) => {
          settings = findSettings(car);

          if (siteSettingsData?.GuardianMode === guardianMode.lockdown) {
            settings.AllowedToMove = stagedCarsChecked;
          } else if (siteSettingsData?.GuardianMode === guardianMode.staging) {
            if (enabledCars?.some((o) => o.GpsiCarId === car?.GpsiCarId)) {
              settings.AllowedToMove = !stagedCarsChecked;
            } else if (
              stagedCars?.some((o) => o.GpsiCarId === car?.GpsiCarId)
            ) {
              settings.AllowedToMove = enabledCarsChecked;
            }
          } else {
            settings.AllowedToMove = stagedCarsChecked;
          }
        });
      }
    }

    carSettingsData?.forEach((item) => {
      const payload = {
        ...item,
        ATMversion: item.ATMversion + 1,
        CarType: newCarType != null ? newCarType === carType.notInUse ? carType.member : newCarType : item.CarType,
        secondaryCarType: secondaryCarType,
        MaxSpeed: speedLimit != null ? speedLimit : item.MaxSpeed,
        MaxHolesAllowedCar: holes != null ? holes : item.MaxHolesAllowedCar,
        DistanceUnits: distance != null ? distance : item.DistanceUnits,
        DistancesEnabledCar: distancesEnabled != null ? distancesEnabled : item.DistancesEnabledCar,
        Deregister: deregister,
        ...(guardianState?.checked !== guardianCapable && {
          GuardianCapable: guardianCapable,
        }),
      };

      updateCarTypeApiCall(payload, headersConfigData)
        .then((response) => response.json())
        .then(() => {
          dispatch(COMMON_SERVICES.getCarServices(false, siteId.get()));
          dispatch(COMMON_SERVICES.getProductData(payload));
        });
    });

    selectedCarList.set([]);
    selectedCarList2.set([]);
    showTaggedCarArrayNew.set([]);
    setCarNumber.set(0);
    carMessageSelector.set([]);
    carsForMessagesGetter.set([]);
    carsGpsSelectorData.set([]);
    carsForMessagesGetter2.set([]);
    carsGpsSelectorData2.set([]);
    selectedSpeedCarList.set([]);
    selectedDistanceUnits.set([]);
    selectCarTypeCarList.set([]);
    selectMaxHolesCarList.set([]);
    selectedDistancesEnabledCar.set([]);
    selectedGpsCarList.set([]);
    closingPopup.set(false);
    toggleSelectedCars.set(false);
    showTaggedCarArray.set([]);
    toggleUnselectedCars.set(true);
    selectFleetCarsData.set([]);
    selectFleetCarsData2.set([]);
    setEnabledCarsChecked(false);
    setStagedCarsChecked(false);
    setCarType(carType.select);
    setHoles(holesConst.select);
    setSpeedLimit(speedLimitConst.select);

    setDistance(null);
    setDistancesEnabled(distances.select);
    dispatch(carProductDataAction({}));
  };

  const closeHandle = () => {
    setActiveButton(false);
    closingPopup.set(false);
    selectedSpeedCarList.set([]);
    selectedDistanceUnits.set([]);
    selectedDistancesEnabledCar.set([]);
    selectMaxHolesCarList.set([]);
    showTaggedCarArray.set([]);
    setCarType(carType.select);
    selectFleetCarsData2.set([]);
    setHoles(holesConst.select);
    setSpeedLimit(speedLimitConst.select);
    setDistance(null);
    setDistancesEnabled(distances.select);
    setCarSettingsData([]);
    dispatch(carProductDataAction({}));
  };
  const userRole = getUserRole && getUserRole?.Role;
  const isValidUser = isUserAdmin(userRole) || isUserSupport(userRole) || isUserMaster(userRole);
  const showCarsData = () => {
    if (selectedCarList.get().length !== 0) {
      return (
        <h2>
          <span className="setting-icon-wrapper">
            <SettingIconNew color="#000" width={14} height={14} />
          </span>
          {selectedCarList.get().length > 1
            ? selectedCarList.get().length > 1 &&
              selectedCarList.get().length < 5
              ? `Cars: ${tx2new}`
              : `${selectFleetCarsData.get()?.length === allCarsData?.length
                ? "All"
                : selectedCarList.get().length
              } Cars`
            : `Car: ${selectedCarList.get()}`}
        </h2>
      );
    } else if (showTaggedCarArrayNew.get().length !== 0) {
      return (
        <h2>
          <span className="setting-icon-wrapper">
            <SettingIconNew color="#000" width={14} height={14} />
          </span>
          {showTaggedCarArrayNew.get().length > 1
            ? showTaggedCarArrayNew.get().length > 1 &&
              showTaggedCarArrayNew.get().length < 5
              ? `Cars: ${tx2new}`
              : `${showTaggedCarArrayNew.get()?.length === allCarsData?.length
                ? "All"
                : showTaggedCarArrayNew.get().length
              } Cars`
            : `Car: ${showTaggedCarArrayNew.get()}`}
        </h2>
      );
    }
  };

  return (
    <ChangeSettingModalWrapper>
      <div className="heading">
        {showCarsData()}
        {!showSettingData &&
          <div style={{ width: "60px", height: "60px", marginTop: "-10px" }}>
            <Loader width="10" height="10" />
          </div>
        }

        <CloseIcon onClick={closeHandle} width={22} height={22} />
      </div>
      <DialogContent>
        <div className="select-wrapper">
          <p>{t("Max_Number_of_Holes")}</p>
          <FormControl size="small">
            <Select
              value={holes}
              name="CarSetting"
              onChange={holesChange}
              disabled={!shouldInputBeEnable}
              IconComponent={ExpandMoreIcon}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={holesConst.useFleetSetting}>{t("Use_fleet_setting")}</MenuItem>
              <MenuItem value={holesConst.nine}>9</MenuItem>
              <MenuItem value={holesConst.eighteen}>18</MenuItem>
              <MenuItem value={holesConst.unlimited}>{t("Unlimited")}</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="select-wrapper">
          <p>{t("Car_type")}</p>
          <FormControl size="small">
            <Select
              value={newCarType}
              name="CarType"
              disabled={!shouldInputBeEnable}
              onChange={(e) => {
                setActiveButton(true);
                setCarType(e.target.value);
                if (e.target.value === carType.notInUse) {
                  setSecondaryCarType(carType.handicap);
                }
                else {
                  setSecondaryCarType(0);
                }
              }}
              IconComponent={ExpandMoreIcon}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={0}>{t("Select..")}</MenuItem>
              <MenuItem value={1}>{t("Fleet_car")}</MenuItem>
              <MenuItem value={3}>{t("Special_needs_cars")}</MenuItem>
              <MenuItem value={2}>{t("Marshal_cars")}</MenuItem>
              <MenuItem value={4}>{t("Beverage_cars")}</MenuItem>
              <MenuItem value={5}>{t("Out_of_service")}</MenuItem>
              {enableMemberCar && <MenuItem value={6}>{t("Member_car")}</MenuItem>}
              {enableMemberCar && <MenuItem value={7}>{t("Member_/_Special_Needs")}</MenuItem>}
            </Select>
          </FormControl>
        </div>

        <div className="select-wrapper">
          <p>{t("Speed_limit")}</p>
          <FormControl size="small">
            <Select
              value={speedLimit}
              disabled={carSettingsData && carSettingsData?.length > 0 && carSettingsData[0].CarType === carType?.member && getFeatureSetOption(
                siteSettingsData?.Features,
                getFeaturesList().member_cars
              ) || !shouldInputBeEnable || guardianState?.disabled}
              name="SpeedLimit"
              onChange={handleSpeedLimit}
              IconComponent={ExpandMoreIcon}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={-2}>{t("Select..")}</MenuItem>
              <MenuItem value={0 | -1}>{t("Default")}</MenuItem>
              <MenuItem value={15}>
                {isSiteUsingYards() ? "15 mph" : "24 kph"}
              </MenuItem>
              <MenuItem value={14}>
                {isSiteUsingYards() ? "14 mph" : "22 kph"}
              </MenuItem>
              <MenuItem value={13}>
                {isSiteUsingYards() ? "13 mph" : "21 kph"}
              </MenuItem>
              <MenuItem value={12}>
                {isSiteUsingYards() ? "12 mph" : "19 kph"}
              </MenuItem>
              <MenuItem value={11}>
                {isSiteUsingYards() ? "11 mph" : "18 kph"}
              </MenuItem>
              <MenuItem value={10}>
                {isSiteUsingYards() ? "10 mph" : "16 kph"}
              </MenuItem>
              <MenuItem value={9}>
                {isSiteUsingYards() ? "9 mph" : "14 kph"}
              </MenuItem>
              <MenuItem value={8}>
                {isSiteUsingYards() ? "8 mph" : "13 kph"}
              </MenuItem>
              <MenuItem value={7}>
                {isSiteUsingYards() ? "7 mph" : "11 kph"}
              </MenuItem>
              <MenuItem value={6}>
                {isSiteUsingYards() ? "6 mph" : "10 kph"}
              </MenuItem>
              <MenuItem value={5}>
                {isSiteUsingYards() ? "5 mph" : "8 kph"}
              </MenuItem>
              <MenuItem value={4}>
                {isSiteUsingYards() ? "4 mph" : "6 kph"}
              </MenuItem>
              <MenuItem value={3}>
                {isSiteUsingYards() ? "3 mph" : "5 kph"}
              </MenuItem>
              <MenuItem value={2}>
                {isSiteUsingYards() ? "2 mph" : "3 kph"}
              </MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="select-wrapper">
          <p>&nbsp;</p>
          <div className="group-btn-wrapper">
            <button
              disabled={!shouldInputBeEnable}
              className={distance === 1 ? "active" : ""}
              onClick={() => yardsHandle(1)}
            >
              {t("Yards")}
            </button>
            <button
              disabled={!shouldInputBeEnable}
              className={distance === 2 ? "active" : ""}
              onClick={() => yardsHandle(2)}
            >
              {t("Meters")}
            </button>
          </div>
        </div>

        <div className="select-wrapper">
          <p>{t("Show/Hide_Distances")}</p>
          <FormControl size="small">
            <Select
              value={distancesEnabled}
              name="HideShowDistance"
              disabled={!shouldInputBeEnable}
              IconComponent={ExpandMoreIcon}
              onChange={(e) => {
                setActiveButton(true);
                setDistancesEnabled(e.target.value);
              }}
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={-1}>{t("Select..")}</MenuItem>
              <MenuItem value={0}>{t("Hide_distances")}</MenuItem>
              <MenuItem value={1}>{t("Show_Distances")}</MenuItem>
              <MenuItem value={2}>{t("Use_fleet_setting")}</MenuItem>
            </Select>
          </FormControl>
        </div>

        <div className="admin-only">
          {isValidUser ? (
            <p>{t("Product_Settings")}</p>
          ) : (
            <div />
          )}

          <div>
            {isValidUser ? (
              <>
                <div className="checkbox-wrapper">
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={<UnCheckIcon />}
                        checked={guardianCapable}
                        disabled={!shouldInputBeEnable || guardianState?.disabled}
                        checkedIcon={<CheckIcon />}
                        onChange={() => {
                          setShowConfirm(true);
                          setGuardianConfirm(true);
                          setActiveButton(true);
                        }}
                      />
                    }
                    label="Guardian capable"
                  />
                </div>
              </>
            ) : (
              <></>
            )}
            <div className="checkbox-wrapper">
              <FormControlLabel
                control={
                  <Checkbox
                    icon={<UnCheckIcon />}
                    checked={deregister}
                    disabled={!shouldInputBeEnable}
                    checkedIcon={<CheckIcon width={20} height={20} />}
                    onChange={() => {
                      if (!deregister) {
                        setShowConfirm(true);
                        setDeregisterConfirm(true);
                        setActiveButton(true);
                      }
                      else
                        setDeregister(false);
                    }}
                  />
                }
                label={t("Deregister_car")}
              />

            </div>

            {showSettingData && (
              <>
                {enabledCars &&
                  enabledCars.length !== 0 &&
                  canStage2() &&
                  isStagingMode() &&
                  !enabledCars.includes(undefined) ? (
                  <div className="checkbox-wrapper flex-wrapper">
                    <input
                      type="checkbox"
                      disabled={!shouldInputBeEnable}
                      checked={stagedCarsChecked}
                      onChange={(e) => {
                        setActiveButton(true);
                        setStagedCarsChecked(e.target.checked);
                      }}
                    />
                    <LockIcon className="mr-5" />
                    <label htmlFor="">{carsStagedString()}</label>
                  </div>
                ) : (
                  <></>
                )}

                {stagedCars &&
                  stagedCars.length !== 0 &&
                  canEnable2() &&
                  isStagingMode() &&
                  !stagedCars.includes(undefined) ? (
                  <div className="checkbox-wrapper">
                    <input
                      type="checkbox"
                      disabled={!shouldInputBeEnable}
                      checked={enabledCarsChecked}
                      onChange={(e) => {
                        setActiveButton(true);
                        setEnabledCarsChecked(e.target.checked);
                      }}
                    />
                    <UnLockIcon className="mr-5" />
                    <label htmlFor="">{carsEnabledString()}</label>
                  </div>
                ) : (
                  <></>
                )}

                {siteSettingsData &&
                  siteSettingsData?.GuardianMode !== 2 &&
                  canEnable2() ? (
                  <div className="checkbox-wrapper flex-wrapper">
                    <input
                      type="checkbox"
                      checked={stagedCarsChecked}
                      disabled={!shouldInputBeEnable}
                      onChange={(e) => {
                        setActiveButton(true);
                        setStagedCarsChecked(e.target.checked);
                      }}
                    />
                    <UnLockIcon className="mr-5" />
                    <label htmlFor="">{lockdownString()}</label>
                  </div>
                ) : (
                  <></>
                )}
              </>
            )}
          </div>
        </div>
      </DialogContent>
      {<span style={warningStyle}> {guardianState?.disabled && t("Guardian_Multicar_Warning") || memberCarFound && t("Member_MultiCar_Info")}</span>}
      <DialogActions>

        <div className="action-buttons">
          <Button
            variant="outlined"
            className={enableSave ? "active" : "disabled"}
            disabled={!enableSave}
            onClick={saveEntity}
          >
            {t("Save")}
          </Button>
          <Button variant="outlined" onClick={closeHandle}>
            {t("Cancel")}
          </Button>
        </div>
      </DialogActions>
      <Modal
        open={showConfirm}
        onClose={() => setShowConfirm(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={confirmPopupStyle}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>{(deregisterConfirm && t("Deregister_Confirm_Msg")) ||
              (guardianConfirm && (!guardianCapable ? t("Guardian_Enable_Msg") :
                t("Guardian_Disable_Msg")))
            }</p>
            <div className="action-btn">
              <button
                onClick={() => {
                  setActiveButton(true);
                  deregisterConfirm && setDeregister(true);
                  if (guardianConfirm) { setGuardianCapable(!guardianCapable); setOkPopUp(true); }
                  setShowConfirm(false);
                  setGuardianConfirm(false);
                  setDeregisterConfirm(false);
                }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button onClick={() => { setShowConfirm(false); setGuardianConfirm(false); setDeregisterConfirm(false); }}>
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
      <Modal
        open={okPopUp}
        onClose={() => setOkPopUp(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={confirmPopupStyle}>
          <PopUpContainer className="py-30">
            <h2></h2>
            <p>
              {t("Guardian_Change_Info")}
            </p>
            <div className="action-btn">
              <button className="primary" onClick={() => setOkPopUp(false)}>
                {t("Ok")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </ChangeSettingModalWrapper>
  );
};
export default CarSettings;
